import { render, staticRenderFns } from "./WrongAnalysisMobile.vue?vue&type=template&id=34ebba0e&scoped=true"
import script from "./WrongAnalysisMobile.vue?vue&type=script&lang=js"
export * from "./WrongAnalysisMobile.vue?vue&type=script&lang=js"
import style0 from "./WrongAnalysisMobile.vue?vue&type=style&index=0&id=34ebba0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34ebba0e",
  null
  
)

export default component.exports